import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replace'
})
export class ReplacePipe implements PipeTransform {

  transform(value: string, valueToReplace: string, replaceValue: string): any {
    return value.replace(valueToReplace, replaceValue);
  }
}